import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import frTranslation from './locales/fr/translation.json';
import arTranslation from './locales/ar/translation.json';
import zhTranslation from './locales/zh/translation.json';
import ruTranslation from './locales/ru/translation.json';
import jaTranslation from './locales/ja/translation.json';
import koTranslation from './locales/ko/translation.json';

// Indic locales — Sarvam-translated page titles (full strings fall back to en)
import hiTranslation from './locales/hi/translation.json';
import bnTranslation from './locales/bn/translation.json';
import guTranslation from './locales/gu/translation.json';
import knTranslation from './locales/kn/translation.json';
import mlTranslation from './locales/ml/translation.json';
import mrTranslation from './locales/mr/translation.json';
import orTranslation from './locales/or/translation.json';
import paTranslation from './locales/pa/translation.json';
import taTranslation from './locales/ta/translation.json';
import teTranslation from './locales/te/translation.json';

const resources = {
  en: { translation: enTranslation },
  es: { translation: esTranslation },
  fr: { translation: frTranslation },
  ar: { translation: arTranslation },
  zh: { translation: zhTranslation },
  ru: { translation: ruTranslation },
  ja: { translation: jaTranslation },
  ko: { translation: koTranslation },
  // Short-code Indic resources (what usePageTitle + manual pickers use)
  hi: { translation: hiTranslation },
  bn: { translation: bnTranslation },
  gu: { translation: guTranslation },
  kn: { translation: knTranslation },
  ml: { translation: mlTranslation },
  mr: { translation: mrTranslation },
  or: { translation: orTranslation },
  pa: { translation: paTranslation },
  ta: { translation: taTranslation },
  te: { translation: teTranslation },
  // BCP-47 aliases (what GuestMenu's Indic picker emits, e.g. "hi-IN")
  "hi-IN": { translation: hiTranslation },
  "bn-IN": { translation: bnTranslation },
  "gu-IN": { translation: guTranslation },
  "kn-IN": { translation: knTranslation },
  "ml-IN": { translation: mlTranslation },
  "mr-IN": { translation: mrTranslation },
  "od-IN": { translation: orTranslation },
  "pa-IN": { translation: paTranslation },
  "ta-IN": { translation: taTranslation },
  "te-IN": { translation: teTranslation }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: localStorage.getItem('language') || 'en', // Get from localStorage or default to English
    debug: true, // Enable debug mode to see i18n logs
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded', // Re-render on language change
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
    }
  });

// Set document dir and lang attributes
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
  document.documentElement.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
  localStorage.setItem('language', lng);
});

// Set initial direction
const currentLang = i18n.language || 'en';
document.documentElement.setAttribute('lang', currentLang);
document.documentElement.setAttribute('dir', currentLang === 'ar' ? 'rtl' : 'ltr');

// Expose i18n to window for debugging
if (typeof window !== 'undefined') {
  window.i18n = i18n;
}

export default i18n;
